import React from 'react'
import NavLink from '../../components/NavLink'
import cx from "classnames";
// import CircleDecor4 from "../Svg/circle-decor-4";
// import CircleDecor5 from "../Svg/circle-decor-5";
import CircleDecor12 from "../Svg/circle-decor-12";
import FactoryProd from "../Svg/factory-prod";

import processingImg from '../../assets/img/factory/processing.png'
import mechProcessingImg from '../../assets/img/factory/mech-processing.png'
import paintingImg from '../../assets/img/factory/painting.png'
import assemblyImg from '../../assets/img/factory/assembly.png'
import weldingImg from '../../assets/img/factory/welding.png'
import Languages from "../../const/languages";
import AppConfig from "../../const/config";

export default ({icon, label, labelPosition, link, className, point, style, isProdBtn, ...props}) => {
    const { locale } = AppConfig;
    const { size, scaleY } = point;
    const transformValue = `translate(-50%, -50%) scaleY(${scaleY})`;

    return (
        <NavLink to={link} style={style} className={cx("hud-map__location hud-map__location__factory", className)} data-label={ label }>
            <div className="hud-map__location__pointer" style={{
                width: size,
                height: size,
                transform: transformValue
            }}>
                {label &&
                    <div className={cx("btn__factory-label", labelPosition && "btn__factory-label_" + labelPosition)}>{label}</div>
                }
                <div className="btn__icon" style={{ width: '100%' }}>
                    {icon && (
                        <img src={icon} alt={''}/>
                    )}
                </div>
                <div className="btn__circles">
                    <div className="btn__circles__circle" style={{ width: '100%' }}>
                        {!isProdBtn && 
                            <CircleDecor12 style={{ width: '100%', height: '100%'}}/>
                        }
                        {isProdBtn && 
                            <div style={{width: '100%'}}>
                                <div className="btn__circles__prod-title">{Languages.production}</div>
                                <FactoryProd
                                    style={{ width: '100%', height: '100%'}}
                                    locale={locale}
                                />
                                <img style={{top: '5.7%', left: '39.6%'}} className="btn__circles__prod-img" src={processingImg} alt={''}/>
                                <img style={{top: '62%', left: '63.6%'}} className="btn__circles__prod-img" src={mechProcessingImg} alt={''}/>
                                <img style={{top: '62%', left: '18.5%'}} className="btn__circles__prod-img" src={paintingImg} alt={''}/>
                                <img style={{top: '29%', left: '70%'}} className="btn__circles__prod-img" src={weldingImg} alt={''}/>
                                <img style={{top: '28.4%', left: '8.5%'}} className="btn__circles__prod-img" src={assemblyImg} alt={''}/>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </NavLink>
    )
}
